import { gql } from '@apollo/client';
import { TRANSLATED_STRING_FIELDS } from '@assets/i18n/config';

export const FETCH_ALERT_BANNERS = gql`
  query fetchAlertBanners($input: FetchAlertBannersInput!) {
    fetchAlertBanners(input: $input) {
      totalCount
      alertBanners {
        id
        name
        roleProfiles {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
        startDate
        endDate
        updatedAt
        state
        organization {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
      }
    }
  }
`;

export const FETCH_ALERT_BANNER = gql`
  query fetchAlertBanner($alertBannerId: ObjectID!) {
    fetchAlertBanner(alertBannerId: $alertBannerId) {
      alertBanner {
        id
        name
        bannerType
        bannerCopy { ${TRANSLATED_STRING_FIELDS} }
        configuration {
          displayOnWeb
          displayOnIOS
          displayOnAndroid
          makeDismissible
          enableAction
        }
        persistenceBehaviour
        actionButton { url label }
        state
        startDate
        endDate
        roleProfiles {
          id
          translatedName { ${TRANSLATED_STRING_FIELDS} }
        }
      }
    }
  }
`;

export const FETCH_VISIBLE_ALERT_BANNERS = gql`
  query fetchVisibleAlertBanners($input: FetchVisibleAlertBannersInput!) {
    fetchVisibleAlertBanners(input: $input) {
      totalCount
      visibleAlertBanners {
        id
      }
    }
  }
`;

export const CREATE_ALERT_BANNER = gql`
  mutation createAlertBanner($input: CreateAlertBannerInput!) {
    createAlertBanner(input: $input) {
      alertBanner {
        id
      }
    }
  }
`;

export const UPDATE_ALERT_BANNER = gql`
  mutation updateAlertBanner($input: UpdateAlertBannerInput!) {
    updateAlertBanner(input: $input) {
      alertBanner {
        id
      }
    }
  }
`;

export const TRANSITION_ALERT_BANNER = gql`
  mutation transitionAlertBanner($input: TransitionAlertBannerInput!) {
    transitionAlertBanner(input: $input) {
      alertBanner {
        id
      }
    }
  }
`;

export const DELETE_ALERT_BANNER = gql`
  mutation deleteAlertBanner($input: DeleteAlertBannerInput!) {
    deleteAlertBanner(input: $input) {
      deleted
    }
  }
`;

export const UPSERT_ALERT_BANNER_INTERACTION = gql`
  mutation upsertAlertBannerInteractions($input: UpsertAlertBannerInteractionsInput!) {
    upsertAlertBannerInteractions(input: $input) {
      alertBannerInteractions {
        id
        alertBanner {
          id
          name
          bannerType
          bannerCopy { ${TRANSLATED_STRING_FIELDS} }
          configuration {
            displayOnWeb
            displayOnIOS
            displayOnAndroid
            makeDismissible
            enableAction
          }
          persistenceBehaviour
          actionButton { url label }
          createdAt
        }
      }
    }
  }
`;

export const TRANSITION_ALERT_BANNER_INTERACTION = gql`
  mutation transitionAlertBannerInteraction(
    $input: TransitionAlertBannerInteractionInput!
  ) {
    transitionAlertBannerInteraction(input: $input) {
      alertBannerInteraction {
        id
      }
    }
  }
`;
